<template>
  <div class="bg-[#23242A] text-white px-8 pb-48 h-screen overflow-y-auto">
    <div class="p-3 flex content-main gap-5">
      <div class="custom-full">
        <template v-if="vg_selectedLocation.id">
            <Nav />
            <div class="bg-[#2B2C32] rounded-lg px-8 mt-1 pt-1 pb-5">

                <block-loading v-if="loading"/>

                <template v-else>
                <div class="bg-[#2B2C32] rounded-lg mt-1 pt-1 pb-5">
                <div class="flex justify-between mb-3">
                    <div>
                        <label class="flex items-center cursor-pointer">
                            <span class="text-[20px] mr-4 text-grey">Delivery</span>
                            <input type="checkbox" v-model="form.deliveryActive" class="hidden peer">
                            <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.deliveryActive ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                            <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.deliveryActive ? 'text-theme-green' : 'text-[#F53333]'">{{form.deliveryActive ? 'On' : 'Off'}}</span>
                        </label>
                    </div>
                    <div><button :disabled="isInvalidToSave()" @click="save()" class="h-10 hover:bg-theme-green disabled:bg-theme-grey disabled:cursor-default disabled:text-theme-green border-0 hover:text-white rounded-[4px] cursor-pointer text-theme-green bg-white py-2 px-4 uppercase ">Save</button></div>
                </div>

                <div>
                    <div class="text-sm">Ordering Options:</div>
                    <div class="ml-2 max-w-[760px]">
                      
                    <div class="admin-table py-4">
                        <label class="cursor-pointer text-sm">
                        <input type="checkbox" value="1" class="mr-3" v-model="form.enableAsap"/>ASAP
                        </label>
                    </div>
                    <div class="admin-table border-t-[2px] border-field-black py-4">
                        <label class="cursor-pointer text-sm">
                        <input type="checkbox" value="1" class="mr-3" v-model="form.deliveryTimeSlots"/>Scheduled Ordering
                        </label>
                    </div>
                    <div class="ml-7 flex flex-col gap-5 relative">

                      <div v-if="form.deliveryTimeSlots == false" class="absolute top-0 left-0 w-full bg-[#2b2c31] h-full opacity-40"></div>
                      
                        <div class="flex flex-col gap-1">
                            <div class="text-sm">Time Slots</div>
                            <div class="text-sm text-grey">Select the length of the time slot the customer can choose.</div>
                            <div :class="'input-wrapper max-w-[260px] ' + (form.timeSlotDuration.error_type)">
                                <select @change="validateFields(['timeSlotDuration'])" v-model.number="form.timeSlotDuration.value" class="border-none block rounded bg-gray-black w-full text-sm">
                                <option value="">-- Select --</option>
                                <option value="15">15 minutes interval</option>
                                <option value="30">30 minutes interval</option>
                                <option value="45">45 minutes interval</option>
                                <option value="60">60 minutes interval</option>
                                <option value="90">90 minutes interval</option>
                                <option value="120">120 minutes interval</option>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.timeSlotDuration.error_message" v-text="form.timeSlotDuration.error_message"></p>
                            </div>
                        </div>

                        <div class="flex flex-col gap-1">
                            <div class="text-sm">Order Prep Time</div>
                            <div class="text-sm text-grey">How long does it take your staff to prepare orders for pickup. This setting is used to prevent orders when time slots are full until they have been prepared.</div>
                            <div :class="'input-wrapper max-w-[260px] ' + (form.orderPrepTime.error_type)">
                                <select @change="validateFields(['orderPrepTime'])" v-model.number="form.orderPrepTime.value" class="border-none block rounded bg-gray-black w-full text-sm">
                                <option value="">-- Select --</option>
                                <option value="15">15 minutes interval</option>
                                <option value="30">30 minutes interval</option>
                                <option value="45">45 minutes interval</option>
                                <option value="60">60 minutes interval</option>
                                <option value="90">90 minutes interval</option>
                                <option value="120">120 minutes interval</option>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.orderPrepTime.error_message" v-text="form.orderPrepTime.error_message"></p>
                            </div>
                        </div>

                        <div class="flex flex-col gap-1">
                            <div class="text-sm">Orders Per Timeslot</div>
                            <div class="text-sm text-grey">Max number of orders that can be placed in each timeslot to control the flow of your orders.</div>
                            <div :class="'input-wrapper ' + (form.orderLimitPerTimeSlot.error_type)">
                                <input :onkeypress="preventNonNumbers" @keyup="validateFields(['orderLimitPerTimeSlot'])" v-model.number="form.orderLimitPerTimeSlot.value" class="max-w-[260px] placeholder-white block bg-gray-black w-full text-sm text-white rounded border-none" type="number">
                                <p class="field-error label-text mt-1" v-if="form.orderLimitPerTimeSlot.error_message" v-text="form.orderLimitPerTimeSlot.error_message"></p>
                            </div>
                        </div>

                        <div class="flex flex-col gap-1">
                            <div class="text-sm">Advanced Ordering</div>
                            <div class="text-sm text-grey">Only allow to set 3 days in advance.</div>
                            <div :class="'input-wrapper max-w-[260px] ' + (form.timeSlotPeriod.error_type)">
                                <select @change="validateFields(['timeSlotPeriod'])" v-model.number="form.timeSlotPeriod.value" class="border-none block rounded bg-gray-black w-full text-sm">
                                <option value="">-- Select --</option>
                                <option value="1">1 day</option>
                                <option value="2">2 days</option>
                                <option value="3">3 days</option>
                                </select>
                                <p class="field-error label-text mt-1" v-if="form.timeSlotPeriod.error_message" v-text="form.timeSlotPeriod.error_message"></p>
                            </div>
                        </div>
                    </div>

                    <div class="mt-10">
                        <div class="text-sm">After Hours Ordering:</div>
                        <div class="admin-table mt-2">
                            <label class="flex items-center cursor-pointer">
                                <input type="checkbox" v-model="form.afterHoursOrdering" class="hidden peer">
                                <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.afterHoursOrdering ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                                <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.afterHoursOrdering ? 'text-theme-green' : 'text-[#F53333]'">{{form.afterHoursOrdering ? 'On' : 'Off'}}</span>
                            </label>
                        </div>
                    </div>

                    <div class="mt-10">
                        <div class="text-sm">Enable/Disable Tips:</div>
                        <div class="admin-table mt-2">
                            <label class="flex items-center cursor-pointer">
                                <input type="checkbox" v-model="form.enableTips" class="hidden peer">
                                <div :class="'relative toggle-bg  border-2  h-6 w-11 rounded-full ' + (form.enableTips ? 'bg-theme-green border-theme-green' : 'bg-[#F53333] border-[#F53333]')"></div>
                                <span class="ml-2 text-white text-sm font-medium uppercase" :class="form.enableTips ? 'text-theme-green' : 'text-[#F53333]'">{{form.enableTips ? 'On' : 'Off'}}</span>
                            </label>
                        </div>
                    </div>

                    <div class="mt-10">
                        <div class="text-sm">Payment Methods Displayed to Customer</div>
                        <div class="admin-table mt-2">
                            <label class="cursor-pointer text-sm">
                                <input type="checkbox" value="1" class="mr-3" v-model="form.payOnline"/>Pay Online
                            </label>
                        </div>
                        <div class="admin-table mt-2">
                            <label class="cursor-pointer text-sm">
                                <input type="checkbox" value="1" class="mr-3" v-model="form.payAtDoorCc"/>At the door - Debit &amp; Credit
                            </label>
                        </div>
                        <div class="admin-table mt-2">
                            <label class="cursor-pointer text-sm">
                                <input type="checkbox" value="1" class="mr-3" v-model="form.payAtDoorCash"/>At the door - Cash
                            </label>
                        </div>
                    </div>

                    </div>
                </div>
                </div>
                </template>
            </div>
        </template>
        <p v-else class="text-center text-theme-red">Please select a location from the top left corner.</p>
      </div>
    </div>
  </div>
</template>


<script lang="ts">
import {defineComponent, ref} from "vue"
import LocationDeliverySettingApi from "@/controllers/LocationDeliverySetting";
import { mapGetters, mapActions, mapMutations } from "vuex";
import Helpers from '@/helpers';
import Nav from "./Nav.vue"
import { useSnackbar } from "vue3-snackbar";

export default defineComponent({
  name: "LocationPickup",
  components: {
    Nav
  },

  setup() {
      const snackbar = useSnackbar();
      const loading = ref(false);
      const has_setting = ref(false);
      const form = <any>ref({
        deliveryActive: false,
        enableAsap: true,
        deliveryTimeSlots: false,
        timeSlotDuration: {
          value: '',
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        orderPrepTime: {
          value: 30,
          error_type: '',
          error_message: '',
          validations: ['required'],
        },
        orderLimitPerTimeSlot: {
          value: 10,
          error_type: '',
          error_message: '',
          validations: ['required', 'positivenumber', 'maxval:99999'],
        },
        timeSlotPeriod: {
          value: 1,
          error_type: '',
          error_message: '',
          validations: ['required', 'positivenumber', 'maxval:99999'],
        },
        cancellationCutoff: {
          value: 10,
          error_type: '',
          error_message: '',
          validations: []
        },
        afterHoursOrdering: false,
        enableTips: false,
        deliverySameAsStoreHours: false,
        payOnline: false,
        payAtDoorCc: false,
        payAtDoorCash: false,
      });

    return {
      form,
      loading,
      snackbar,
      has_setting
    };
  },

   watch : {
    'vg_selectedLocation'(val) {
      this.fetchLocationPickupSetting();
    },
    'form.orderLimitPerTimeSlot.value'(val) {
      this.form.orderLimitPerTimeSlot.value = val ? Math.trunc(val) : '';
    },

    'form.deliveryTimeSlots'(val) {
      if(val == false) {
        this.form = Helpers.removeValidationOnly(this.form, ['timeSlotDuration', 'orderPrepTime', 'orderLimitPerTimeSlot', 'timeSlotPeriod']);
      }else{
        this.form.enableAsap = false
      }
    },
    'form.enableAsap'(val){
      if(val){
        this.form.deliveryTimeSlots = false
      }
    }
  },

  computed: {
    ...mapGetters({
      vg_selectedLocation: 'location/selected'
    }),
  },
 

  async mounted() {
    this.loading = true;
    await this.fetchLocationPickupSetting();
    this.loading = false;
  },

  methods: {
    isInvalidToSave(){
      if(!this.form.deliveryActive) return false

      if(!this.form.enableAsap && !this.form.deliveryTimeSlots) return true

      if(!this.form.payOnline && !this.form.payAtDoorCash && !this.form.payAtDoorCc) return true

      return false
    },
    
    /**
     * Validation captures
     */
    async validateFields(fields) {
      let res = await Helpers.validateFormFields(this.form, fields);
      // capture the fields
      this.form = res.data;
      return res.error ? false : true;
    },

    preventNonNumbers(evt) {
      var ASCIICode = (evt.which) ? evt.which : evt.keyCode
      if(ASCIICode == 43 || ASCIICode == 45){
        return false;
      }
      return true;
    },

    /**
     * Fetch business branding
     */
    async fetchLocationPickupSetting() {
      this.loading = true;
      let res = await LocationDeliverySettingApi.fetchLocationDeliverySetting();
      this.loading = false;
      if(res.status == 200) {
        this.has_setting = true;
        this.form = <any>Helpers.assignFormValues(this.form, res.data.payload);
      } else {
        this.has_setting = false;
        this.form = <any>Helpers.assignFormValues(this.form, {});
      }
    },

    /**
     * Create business branding
     */
    async save() {
      // validate only if delivery timeslots
      let validate = true;
      if(this.form.deliveryTimeSlots == true) {
        validate = await this.validateFields(['timeSlotDuration', 'orderPrepTime', 'orderLimitPerTimeSlot', 'timeSlotPeriod']);
      }
    
      if(!validate) {
        return ;
      }
      if(this.has_setting) {
        this.updateSetting();
      } else {
        this.createSetting();
      }
    },

    /**
     * Create setting 
     */
    async createSetting() {
      this.va_spinner(true);
      let res = await LocationDeliverySettingApi.createLocationDeliverySetting(Helpers.getFormKeyValue(this.form));
      this.va_spinner(false);

      if(res.status == 201) {
        this.has_setting = true;
      }
      
      this.snackbar.add({
        type: 'info',
        text: res.status == 201 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

    /**
     * Update setting 
     */
    async updateSetting() {
      this.va_spinner(true);
      let res = await LocationDeliverySettingApi.updateLocationDeliverySetting(Helpers.getFormKeyValue(this.form));
      this.va_spinner(false);
      this.snackbar.add({
        type: 'info',
        text: res.status == 200 ? res.data.message : Helpers.catchErrorMessage(res.response.data),
        duration: 3000,
      })
    },

    ...mapMutations({

    }),

    ...mapActions({
      va_spinner: 'spinner/setSpinner',
    })

  },
});

</script>

